import { AuthService } from '@marina/auth';

/** First screen after login / marina switch (delegates to AuthService). */
export function getHomeUrlPathForCurrentMarina(authService: AuthService): string {
  return authService.getStaffPortalHomePath();
}
